// extracted by mini-css-extract-plugin
export default {"switch":"switch--wcGdC","slider":"slider--__iFh"};